import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/animal-debt/project-overview-back.webp";

function Projectoverview() {
  return (
    <section
      className="project-overview-animal p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="order-2 order-md-1"
          >
            <div className="img">
              <StaticImage
                src="../../../images/case-studies/animal-debt/Client-Overview.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={752}
                height={507}
              />
            </div>
            <div className="client-img-main">
              <div className="client-img-item">
                <StaticImage
                  src="../../../images/case-studies/animal-debt/Client-Overview-1.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={160}
                  height={153}
                />
              </div>
              <div className="client-img-item">
                <StaticImage
                  src="../../../images/case-studies/animal-debt/Client-Overview-2.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={160}
                  height={153}
                />
              </div>
              <div className="client-img-item">
                <StaticImage
                  src="../../../images/case-studies/animal-debt/Client-Overview-3.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={160}
                  height={153}
                />
              </div>
              <div className="client-img-item">
                <StaticImage
                  src="../../../images/case-studies/animal-debt/Client-Overview-4.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={160}
                  height={153}
                />
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="order-1 order-md-2"
          >
            <h2 style={{ color: "#000" }}>
              <span style={{ color: "#007F6E" }}>Client & Project</span>{" "}
              Overview
            </h2>
            <h3 style={{ color: "#000", marginBottom: "10px" }}>
              About the Client
            </h3>
            <p>
              Gray, a renowned game reviewer, is known for his unfiltered and
              humorous takes on video games. With a knack for finding the
              quirkiest games, he decided to step into game development, aiming
              to create something completely out of the ordinary. His idea? A
              game that combines absurdity, humor, and puzzles to create a
              unique experience.
            </p>
            <ul className="mb-4 mb-md-0">
              <li>
                <strong>Industry</strong>: Gaming
              </li>
              <li>
                <strong>Business Type</strong>: Independent Game Developer
              </li>
              <li>
                <strong>Services Provided</strong>: Game Development, Game
                Design, Puzzle Integration, UX/UI, Game Art, Game Publishing.
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Projectoverview;
